import React from 'react';
import { Menu } from 'semantic-ui-react'
import { useNavigate } from "react-router";
import { useLocation } from "react-router-dom";

export function Header(props) {
	const navigate = useNavigate();
	const location = useLocation();
	const activeItem = location.pathname.split('/')[1];

	const onClickHandler = (e, link) => {
		if(e.ctrlKey || e.metaKey){
			window.open(link, '_blank');
		} else {
			navigate(link);
		}
	}

	return (
      <div className="App-header">
        <Menu pointing secondary>
          <Menu.Item header
            active={activeItem === ''}
            onClick={(e) => onClickHandler(e, '/')}
          >Jazz Vocalists UK</Menu.Item>
          <Menu.Item
            name='artists'
            active={activeItem === 'artist'}
            onClick={(e) => onClickHandler(e, '/artist')}/>
          <Menu.Item
            name='acts'
            active={activeItem === 'act'}
            onClick={(e) => onClickHandler(e, '/act')}/>
          <Menu.Item
            name='concerts'
            active={activeItem === 'concert'}
            onClick={(e) => onClickHandler(e, '/concert')}/>
          <Menu.Item
            name='playlist'
            active={activeItem === 'playlist'}
            onClick={(e) => onClickHandler(e, '/playlist')}/>

          <Menu.Item
            name='Sinatraology'
            href='https://sinatraology.com'
          />
        </Menu>
      </div>
    );
} 
